module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    ref: "main-toolbar",
    staticClass: "primary",
    attrs: {
      "fixed": "",
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('v-icon', [_vm._v("\n            arrow_back\n        ")])], 1), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "d-flex",
    staticStyle: {
      "position": "relative"
    },
    domProps: {
      "textContent": _vm._s(_vm.$store.state.nav.title)
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f72ab1dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainToolbar.vue
// module id = 340
// module chunks = 2